/**
 * View
 */
import Config from '../Config';
import Util from '../Util';
import Loading from '../Loading';
import ViewMenu from './ViewMenu';
import Vote from './Vote';
import Scrap from './Scrap';
import ParamInfo from './ParamInfo';
import Report from './Report';
import Delete from './Delete';
import Update from './Update';
import Viewer from './Viewer';
import Share from './Share';
import ViewCharacterInfo from './ViewCharacterInfo';
import GoToTop from '../GoToTop';
import SandboxLike from './sandbox/SandboxLike';
import ArticleNavigation from './ArticleNavigation';
import Plugin from './plugin/Plugin';
import Speech from './playground/Speech';
import CommentAnchor from './comment/CommentAnchor';

// import PrevNextArticle from './PrevNextArticle';

class View {

	public onLoaded: any;

	public onSignLoaded: any;

	protected _id: string;

	protected paramInfo: ParamInfo;

	private $node: any;

	private articleId: string;

	private isNotice: boolean;

	private guid: string;

	private loading: Loading;

	private bodyElement: string;

	private voteButton: string;

	private moreButton: string;

	private commentCount: string;

	private sandBoxButton: string;

	private firstBr: string;

	private viewSignatureCls: string;

	private viewSignature: string;

	private gameUserUid: string;

	private gameServerId: string;

	private gameCharacterId: string;

	private gameCharacterName: string;

	private uid: string;

	private scrap: Scrap;

	private delete: Delete;

	private update: Update;

	private viewer: Viewer;

	private share: Share;

	private viewMenu: ViewMenu;

	private report: Report;

	private commentAnchor: CommentAnchor;

    private isAdminUser: boolean;

	constructor( node: any, options: any ) {
		const param = Util.getParams();

		this.$node = node;

		this.$node.addClass( Config.COMMUNITY_NODE );

		this._id = this.$node.attr( 'id' );

		this.isAdminUser = null;

		jQuery.extend( true, Config, options );

		// @TODO test speech
		if ( Util.net( '' ) === 'opdev' ) {
			Config.isSpeech = true;
		}

		Config.view = ( options.viewAPIUrl ) ? options.viewAPIUrl : Config.view;

		this.articleId = Config.__secretArticleId || parseInt( param.articleId, 10 );

		this.isNotice = ( param.isNotice === '1' ) ? true : false;

		this.guid = '';

		this.loading = new Loading( this.$node );
		this.loading.setUI();
		this.loading.show();

		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();

		this.commentAnchor = new CommentAnchor();

		this.addSelector();
		this.addEvent();
		this.addObserver();
	}

	public getData( _template: any ) {
		const _data: any = {};
		const _categoryId = this.paramInfo.getParamByKey( 'categoryId' ) || '';
		const viewUrl = Util.Tmpl.render({
			data: {
				articleId: this.articleId,
				board: Config.board,
			},
			template: ( !this.isNotice ) ? Config.view : Config.noticeView,
		});

		if ( this.isNotice && _categoryId ) {
			_data.categoryId = _categoryId;
		}

		const viewPromise = Util.get( viewUrl, 'get', _data );
		const get$ = Util.from( viewPromise );
		get$.subscribe( ( data: any ) => {

			data = Util.convertCamelCase( data );
			this.loaded( data, _template );

		}, ( data: any ) => {
			if ( data.status === 400 ) {
				// location.href = Config.listPage;
			}

			if ( data.status === 401 ) {
				// Config.apiError( data );
			}

			this.loaded( 'error', '' );

			this.loading.hide();
		});
	}

	protected addEvent() {
		// addEvent
	}

	private addObserver() {
		this.onLoaded = new Util.Observer();
		this.onLoaded.add( () => {
			if ( Config.isShowPrevNextNavigation ) {
				const articleNavigation = new ArticleNavigation( this.$node );
				articleNavigation.get( this.articleId, Config.prevNextNavigationSize );
			}

			if ( Config.isVote ) {
				const votePlugin = new Plugin( 'View', 'Vote', Config.board );
				votePlugin.addPlugin();
			}

			// @TODO tmp speech API
			if ( Config.isSpeech ) {
				const speech = new Speech();
			}

			this.commentAnchor.goToComment( 'onViewLoaded' );

            if (!this.isAdminUser) {
                jQuery('body').on('click', '.view-body a',(e) => {
                    e.preventDefault();
                    return false;
                });
            }
		});

		this.onSignLoaded = new Util.Observer();
		this.onSignLoaded.add( () => {
			this.commentAnchor.goToComment( 'onSignLoaded' );
		});
	}

	private addSelector() {
		this.bodyElement = `body`;
		this.voteButton = `#${this._id} .co-btn-like`;
		this.moreButton = `#${this._id} .ncCommunityMoreButton`;
		this.commentCount = `#ncCommunityComment .commentTotalCount`;
		this.sandBoxButton = `.view-utils`;
		this.firstBr = `.view-body > [ data-contents-type=text ]:eq( 0 ):has( br )`;
		this.viewSignatureCls = `.view-signature`;
		this.viewSignature = `#${this._id} ${this.viewSignatureCls}`;
	}

	private hideSignature( tmp?: any ) {
		( tmp ) ?
			jQuery( tmp ).find( this.viewSignatureCls ).hide() :
			jQuery( this.viewSignature ).hide();
	}

	private showSignature() {
		jQuery( this.viewSignature ).show();
		this.onSignLoaded.emit();
	}

	private loaded( data: any, _template: any ) {

		Config.viewData = data;

		if ( data === 'error' || !data.article ) {
			this.loading.hide();
			this.onLoaded.emit();
			return;
		}

		// 이전 다음 아티클 데이터
		Config.prevNextData = data.prevNextArticleEntries || '';

		// set boardAlias for Top notice comment
		Config.viewBoardAlias = data.article.boardAlias;
		Config.viewBoardObserver.emit( Config.viewBoardAlias );

		this.guid = data.article.writer.loginUser.uid;
		this.gameUserUid = data.article.writer.gameUser.gameUserUid;
		this.gameServerId = data.article.writer.gameUser.gameServerId;
		this.gameCharacterId = data.article.writer.gameUser.gameCharacterId;
		this.gameCharacterName = data.article.writer.gameUser.gameCharacterName;
		this.uid = data.article.writer.loginUser.uid;
        this.isAdminUser = data.article.writer.adminUser;

		const tmp = _template.view( data, this.isNotice );
		this.$node.append( tmp );
		this.hideSignature();

		// 메뉴
		this.viewMenu = new ViewMenu( this.$node, this.isNotice );

		// 추천
		if ( !Config.isSandboxLike ) {
			const vote = new Vote( Config.guid, data );
		} else {
			jQuery( this.voteButton ).hide();
			const sandboxLike = new SandboxLike( jQuery( this.sandBoxButton ), Config.board, this.articleId );
		}

		// 스크랩
		this.scrap = new Scrap( this._id );

		// 삭제
		this.delete = new Delete( this.guid, this._id, this.gameCharacterName, this.gameServerId );

		// 수정
		this.update = new Update( this.guid, this._id, this.gameCharacterName, this.gameServerId );

		// 신고
		this.report = new Report( jQuery( this.bodyElement ),
			data.article.writer.gameUser.gameCharacterName || data.article.writer.loginUser.name, this._id );

		// 뷰어
		this.viewer = new Viewer();

		// 공유하기
		this.share = new Share();

		// 시그니처 리셋
		if ( Config.isGameSignature && this.gameServerId && Config.serverName[ this.gameServerId ] ) {
			// let _viewCharacterInfo = new ViewCharacterInfo( this.$node, this.gameUserUid, this.gameServerId, this.uid, Config.guid, this.gameCharacterId );
			const _viewCharacterInfo: ViewCharacterInfo = new ViewCharacterInfo( this.$node, data.article.writer.gameUser,  data.article.writer.loginUser );
			_viewCharacterInfo.onLoaded.add( () => {
				this.showSignature();
			});
			_viewCharacterInfo.onFailed.add( () => {
				this.showSignature();
			});
		} else {
			this.showSignature();
		}

		this.loading.hide();

		this.setCommentCount( data );

		this.hideMoreButton();

		this.removeFirstBr();

		// @desc show the Top button
		GoToTop.show();

		this.onLoaded.emit();
	}

	// @deprecated
	private hideMoreButton() {
		const $moreButton = jQuery( this.moreButton );
		if ( $moreButton.find( 'ul' ).has( 'li' ).length === 0 ) {
			$moreButton.hide();
		}
	}

	// @deprecated
	private setArticleNavigation() {
		const articleNavigation = new ArticleNavigation( this.$node );
		articleNavigation.get( this.articleId, 10 );
	}

	private setCommentCount( data: any ) {
		jQuery( this.commentCount ).text( data.article.commentCount );
	}

	private removeFirstBr() {
		const selector = jQuery( this.firstBr );

		if ( selector.text() === '' ) {
			selector.height( 0 );
		}
	}
}

export default View;
